import { render, staticRenderFns } from "./UploadFace.vue?vue&type=template&id=f9d5cfd0&"
import script from "./UploadFace.vue?vue&type=script&lang=js&"
export * from "./UploadFace.vue?vue&type=script&lang=js&"
import style0 from "./UploadFace.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports